import { LISTING_TYPE_TO_INFRASTRUCTURE } from "../hooks/useMasterFacilityTypes";

function inc(map, key) {
  if (key == null || key === "") return;
  const k = String(key);
  map.set(k, (map.get(k) || 0) + 1);
}

function trackLocation(target, location) {
  const trimmed = location == null ? "" : String(location).trim();
  if (!trimmed) return;
  target.add(trimmed.toLowerCase());
}

function trackLocationForKey(map, key, location) {
  const trimmed = location == null ? "" : String(location).trim();
  if (!trimmed || key == null || key === "") return;
  const k = String(key);
  if (!map.has(k)) map.set(k, new Set());
  map.get(k).add(trimmed.toLowerCase());
}

export function buildInfraListingStatsIndex(listings = []) {
  const byListingType = { property: 0, machinery: 0 };
  const byAssetCategory = new Map();
  const bySubCategory = new Map();
  const bySubSubCategory = new Map();
  const subCategoriesByAssetCategory = new Map();
  const subSubCategoriesBySubCategory = new Map();
  const locationsByListingType = { property: new Set(), machinery: new Set() };
  const locationsByAssetCategory = new Map();
  const locationsBySubCategory = new Map();
  const locationsBySubSubCategory = new Map();

  for (const listing of listings) {
    const listingType = listing?.listingType;
    const assetCategoryId = listing?.assetCategoryId;
    const subCategoryId = listing?.subCategoryId;
    const subSubCategoryId = listing?.subSubCategoryId;
    const location = listing?.locationLine;

    if (listingType === "property" || listingType === "machinery") {
      byListingType[listingType] += 1;
      trackLocation(locationsByListingType[listingType], location);
    }

    if (assetCategoryId) {
      inc(byAssetCategory, assetCategoryId);
      trackLocationForKey(locationsByAssetCategory, assetCategoryId, location);
      if (subCategoryId) {
        const assetKey = String(assetCategoryId);
        if (!subCategoriesByAssetCategory.has(assetKey)) {
          subCategoriesByAssetCategory.set(assetKey, new Set());
        }
        subCategoriesByAssetCategory.get(assetKey).add(String(subCategoryId));
      }
    }

    if (subCategoryId) {
      inc(bySubCategory, subCategoryId);
      trackLocationForKey(locationsBySubCategory, subCategoryId, location);
      if (subSubCategoryId) {
        const subKey = String(subCategoryId);
        if (!subSubCategoriesBySubCategory.has(subKey)) {
          subSubCategoriesBySubCategory.set(subKey, new Set());
        }
        subSubCategoriesBySubCategory.get(subKey).add(String(subSubCategoryId));
      }
    }

    if (subSubCategoryId) {
      inc(bySubSubCategory, subSubCategoryId);
      trackLocationForKey(locationsBySubSubCategory, subSubCategoryId, location);
    }
  }

  return {
    byListingType,
    byAssetCategory,
    bySubCategory,
    bySubSubCategory,
    subCategoriesByAssetCategory,
    subSubCategoriesBySubCategory,
    locationsByListingType,
    locationsByAssetCategory,
    locationsBySubCategory,
    locationsBySubSubCategory,
  };
}

export function buildFacilityTypeCountIndex(facilityTypes = []) {
  const byInfrastructureType = { 1: 0, 2: 0 };
  for (const row of facilityTypes) {
    const infraType = Number(row.infrastructure_type);
    if (infraType === 1 || infraType === 2) {
      byInfrastructureType[infraType] += 1;
    }
  }
  return byInfrastructureType;
}

export function enrichInfraBrowseItems({
  depth,
  items = [],
  listingStats,
  facilityTypeCounts,
  infraType,
}) {
  if (!items.length) return items;

  return items.map((item) => {
    const id = String(item.id);

    if (depth === 0) {
      const infraKey = LISTING_TYPE_TO_INFRASTRUCTURE[id];
      return {
        ...item,
        product_count: listingStats?.byListingType?.[id] ?? 0,
        supplier_count: infraKey != null ? facilityTypeCounts?.[infraKey] ?? 0 : 0,
        buyer_request_count: listingStats?.locationsByListingType?.[id]?.size ?? 0,
      };
    }

    if (depth === 1) {
      return {
        ...item,
        product_count: listingStats?.byAssetCategory?.get(id) ?? 0,
        supplier_count: listingStats?.subCategoriesByAssetCategory?.get(id)?.size ?? 0,
        buyer_request_count: listingStats?.locationsByAssetCategory?.get(id)?.size ?? 0,
      };
    }

    if (depth === 2) {
      return {
        ...item,
        product_count: listingStats?.bySubCategory?.get(id) ?? 0,
        supplier_count:
          infraType === "machinery"
            ? listingStats?.subSubCategoriesBySubCategory?.get(id)?.size ?? 0
            : 0,
        buyer_request_count: listingStats?.locationsBySubCategory?.get(id)?.size ?? 0,
      };
    }

    return {
      ...item,
      product_count: listingStats?.bySubSubCategory?.get(id) ?? 0,
      supplier_count: 0,
      buyer_request_count: listingStats?.locationsBySubSubCategory?.get(id)?.size ?? 0,
    };
  });
}
